import React from 'react';
import farmAppLogo from '../../assets/landing/logo/farm-app-logo.png';
import companyLogo from '../../assets/landing/logo/company_logo.png';
import { makeStyles } from '@mui/styles';
import { AppBar, Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: '100vh',
    margin: 'auto',
  },
  featureText: {
    fontSize: '10px !important',
    textAlign: 'center',
    marginBottom: '8px !important',
  },
  title: {
    fontSize: '18px !important',
    margin: '8px 0px 8px 0px  !important',
  },
  subTitle: {
    fontSize: '16px !important',
    lineHeight: '18px !important',
  },
}));

const Navbar = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div>
      <AppBar
        position="static"
        elevation={0}
        sx={{ background: 'transparent', boxShadow: 'none' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {/* Left Section: Logos */}

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img
                src={farmAppLogo}
                alt="FarmApp"
                style={{
                  height: '73px',
                  width: '109px',
                  top: '24px',
                  position: 'relative',
                }}
              />
            </Link>
            <Box
              sx={{
                width: '1px',
                height: '40px',
                backgroundColor: '#54BD95CC',
                position: 'relative',
                top: '40px',
              }}
            />
            <Link
              to="https://asqi.in/"
              style={{ textDecoration: 'none' }}
              target="_blank"
            >
              <img
                src={companyLogo}
                alt="ASQI"
                style={{
                  height: '161px',
                  width: '161px',
                  top: '-19px',
                  position: 'relative',
                }}
              />
            </Link>
          </Box>

          {/* Center Section: Navigation Links */}
          <Box
            sx={{
              display: 'flex',
              width: '60%',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <Typography
                  className={classes.title}
                  sx={{ fontWeight: 'bold', cursor: 'pointer', color: 'black' }}
                >
                  {t('Home')}
                </Typography>
              </Link>
              <Link
                to="https://asqi.in/blogs"
                style={{ textDecoration: 'none' }}
                target="_blank"
              >
                <Typography
                  className={classes.title}
                  sx={{ color: '#A6A6A6', cursor: 'pointer' }}
                >
                  {t('Blog')}
                </Typography>
              </Link>
              <Link
                to="https://asqi.in/about-us/"
                style={{ textDecoration: 'none' }}
                target="_blank"
              >
                <Typography
                  className={classes.title}
                  sx={{ color: '#A6A6A6', cursor: 'pointer' }}
                  target="_blank"
                >
                  {t('About Us')}
                </Typography>
              </Link>
            </Box>
            {/* Right Section: Login and Sign Up */}
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <Typography
                  className={classes.subTitle}
                  sx={{ color: '#A6A6A6', cursor: 'pointer' }}
                >
                  {t('Login')}
                </Typography>
              </Link>
              <Link to="/enquiry">
                <Button
                  variant="contained"
                  className={classes.subTitle}
                  sx={{
                    backgroundColor: '#54BD95',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#4ba683',
                    },
                    borderRadius: '10px',
                    padding: '10px',
                    textTransform: 'none',
                  }}
                >
                  {t('Enquiry')}
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>
      </AppBar>
    </div>
  );
};

export default Navbar;
